interface PageHeaderProps {
  title?: string;
  imageUrl?: string;
  breadcrumbs?: string[];
}

function PageHeader({ title, imageUrl, breadcrumbs }: PageHeaderProps) {
  return (
    <>
      <div className="bg-gradient-to-b from-[#021936] to-[#05326D]">
        <div className="max-w-[var(--max-width)] mx-auto h-92 md:h-70 relative">
          <div className="absolute top-2 right-4 sm:right-6 md:right-12 lg:right-20 xl:right-32 text-white text-xs sm:text-md md:text-md lg:text-lg xl:text-xl py-1">
            +91 9769638029 <span className="text-[#4066AD] text-sm font-semibold px-2">|</span> info@fdacadvancedsolutions.com
          </div>
          <div className="absolute bottom-10 left-4 sm:left-6 md:left-12 lg:left-20 xl:left-32 py-1">
            <h1 className="inline-block relative text-2xl sm:text-5xl md:text-5xl lg:text-5xl xl:text-5xl text-white mb-4 font-normal">
              {title}
              <span className="absolute right-0 -bottom-4 w-[60px] border-b-[8px] border-[#B5AB28] rounded-[6px]"></span>
            </h1>
          </div>
          <div className="absolute bottom-30 sm:-bottom-10 md:-bottom-40 right-4 sm:right-6 md:right-12 lg:right-20 xl:right-32 text-white text-4xl md:text-5xl py-1">
            <img src={imageUrl} alt="Service" className="w-[200px] md:w-full object-top" />
          </div>
        </div>
      </div>
      {/* Dynamic Breadcrumbs */}
      <div className="max-w-[var(--max-width)] mx-auto text-sm px-4 sm:px-6 md:px-12 lg:px-20 xl:px-32 pt-2">
        <div className="text-[#05326D]">
          {breadcrumbs?.map((crumb, index) => (
            <span key={index}>
              <span className={index === breadcrumbs.length - 1 ? "text-gray-500" : ""}>
                {crumb}
              </span>
              {index < breadcrumbs.length - 1 && " > "}
            </span>
          ))}
        </div>
      </div>
    </>
  );
}

export default PageHeader;
